import React from 'react';

import Header from '@components/Header';
import Footer from '@components/Footer';
import Form from '@components/Form';

const Registration = () => {

  return (
    <>
      <Header />
      <Form />
      <Footer />
    </>
  );
}

export default Registration;
